import React from 'react';
import {useSelector} from 'react-redux';
import {ExternalLinkIcon} from '../../icons/Icons';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';

function ShopifyMultipassLogin() {
  const multipass_enabled = useSelector((state)=>state.settings.multipass_enabled)
  if(multipass_enabled){
    return  <small className={"d-block multipass_link"}>
      <Link to={"/sso/store"}
            className={"d-inline-flex align-items-center"}
            rel={"noopener noreferrer nofollow"}><span className="mr-1"><FormattedMessage id={"Access customer account"} /></span><ExternalLinkIcon size={10}  /></Link>
    </small>
  }
  return null;
}

export default ShopifyMultipassLogin;
